<template>
    <div class="input-error" :class="$props.message ? 'invalid' : 'hidden'"><i class="fas fa-exclamation-triangle"></i>{{ $props.message }}</div>
</template>

<script>
    export default {
        props: {
            message: {
                type: String
            }
        }
    }
</script>
